import i18n from 'i18n';

export const PARTNER = i18n.t('Partner');
export const TRANSACTION = i18n.t('Transaction');
export const PROXY_SERVER = i18n.t('Proxy Server');

export const NO_PARTNER_REFS = i18n.t('<No Partners>');
export const NO_TRANS_REFS = i18n.t('<No Transactions>');
export const NO_SYNC_REFS = i18n.t('<No Synchronizations>');
export const NO_SFTP_REFS = i18n.t('<No File Transfer Server Users>');

export const PARTNER_REFERENCE_TITLE = i18n.t('Related Transactions and Synchronizations');
export const KEY_REFERENCE_TITLE = i18n.t('Related Partners and Transactions');
export const PROXY_REFERENCE_TITLE = i18n.t('Related Partners, Transactions and Synchronizations');

export const partnerRefLabel = (item: string) => i18n.t('Partners Using {{item}}', {item});
export const transRefLabel = (item: string) => i18n.t('Transactions Using {{item}}', {item});
export const syncRefLabel = (item: string) => i18n.t('Synchronizations Using {{item}}', {item});
export const sftpRefLabel = (item: string) =>
   i18n.t('File Transfer Server Users Using {{item}}', {item});

// export const FATAL_ERROR = i18n.t(
//    'An fatal error occured. Please contact the support and refresh page to continue.'
// );
